
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont ses points faibles?`}</em></p>
    <p>{`Les résultats intermédiaires des essais cliniques sont décevants. Ils montrent
une efficacité insuffisante, qui contraste avec celle des deux autres vaccins à
ARNm (ceux de Pfizer/BioNTech et de Moderna). Cela pourrait s'expliquer par le
faible dosage ou encore par le fait que les développeurs ont décidé de ne pas
stabiliser l'ARN messager synthétique.`}</p>
    <p>{`Le 8 juin, l'agence Reuters a révélé que l'agence européenne des médicaments ne
compte pas prendre de décision concernant ce vaccin avant le mois d'août. Et le
laboratoire allemand a dû réviser son calendrier sur le développement de son
produit: il a repoussé de mai à juin la date estimée des premiers résultats d’un
essai de phase avancée.`}</p>
    <p>{`Ce vaccin serait meilleur marché que les deux autres utilisant l’ARNm (le
gouvernement belge aurait payé 10 euros, selon des chiffres diffusés en décembre
2020). Ceci dit, cela n’en fait pas l’un des moins cher.`}</p>
    <p>{`De façon générale, l’emploi de l’ARN messager, une nouvelle technologie passant
par la génétique, crée une certaine `}<a parentName="p" {...{
        "href": "404485565357"
      }}>{`appréhension`}</a>{` dans la
population. Alessandro Diana, expert des vaccins, se montre rassurant: l’ARN
messager n’entre pas dans le noyau de nos cellules (où notre matériel génétique
est stocké), le code envoyé à nos cellules disparaît rapidement de notre corps
et ce vaccin est sûr.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;